/**
 * Generated runtime TestId mirror for frontend/src/components/form-layout/designer/LayoutCanvas.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const LayoutCanvasTestIds = {
  canvasAddSectionBtn: "canvas-add-section-btn",
  canvasAddSectionMoreBtn: "canvas-add-section-more-btn",
  canvasEmptyTitle: "canvas-empty-title"
} as const;
